"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateData = exports.useCirrusStorePut = void 0;
const react_cirrus_1 = require("@yanzi/react-cirrus");
const socket_1 = require("@yanzi/socket");
const react_1 = require("react");
const react_query_1 = require("react-query");
const useCirrusStoreGet_1 = require("./useCirrusStoreGet");
function useCirrusStorePut(contentType = 'application/json') {
    const { socket } = react_cirrus_1.useCirrus();
    const queryCache = react_query_1.useQueryCache();
    const [mutate, res] = react_query_1.useMutation(({ url, data }) => __awaiter(this, void 0, void 0, function* () {
        const buffer = yield generateData(data, contentType);
        return yield socket.storePutRequest({ messageType: 'StorePutRequest', url }, [buffer]);
    }), {
        onSuccess: (_, { url }) => {
            queryCache.invalidateQueries(useCirrusStoreGet_1.cirrusStoreCacheKey(socket, url));
        },
    });
    const putContent = react_1.useCallback((url, data) => {
        return mutate({ url, data });
    }, [mutate]);
    return react_1.useMemo(() => [putContent, Object.assign(Object.assign({}, res), { loading: res.isLoading })], [putContent, res]);
}
exports.useCirrusStorePut = useCirrusStorePut;
function generateData(data, contentType) {
    return __awaiter(this, void 0, void 0, function* () {
        switch (contentType) {
            case 'application/json':
                return socket_1.stringToBuffer(JSON.stringify(data));
            case 'file':
                return yield new Promise(resolve => {
                    const fileReader = new FileReader();
                    fileReader.addEventListener('loadend', () => resolve(fileReader.result));
                    fileReader.readAsArrayBuffer(data);
                });
            case 'raw':
                return data;
            default:
                throw new Error('Invalid content type');
        }
    });
}
exports.generateData = generateData;
//# sourceMappingURL=useCirrusStorePut.js.map